import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get } from '../../modules/logistics/supplier';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state, ownProps) => {
	const supplierId = (ownProps.supplierId)
		? ownProps.supplierId
		: _.get(ownProps, ['match', 'params', 'supplierId']);
	const supplier = _.get(state.maps, ['supplier', supplierId]);

	return {
		supplier
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getSupplier : get,
	addSupplier : add,
	updateSupplier : update,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
